import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, InputAdornment, MenuItem, TablePagination, Tooltip } from "@mui/material";
import Loader from "../../../components/common/loader/Loader";
import InfoIcon from "@mui/icons-material/Info";
// import { CiFilter } from "react-icons/ci";
import { StyledWelcomeBanner, StyledWrapper } from "../../dashboard/style";
import {
  StyledBoxStyle,
  StyledCustomerSearch,
  StyledOrdersContainer,
  StyledStatusFilter,
  StyledTableLayout,
} from "./style";
import {
  StyledSearchIcon,
  StyledTypographyText,
} from "../../virtual-locker/style";
// import { StyledButtonSend } from "../../../components/chat-box/style";
// import {DashboardStatistics} from "../../../components/admin/dashboard/StatisticsComponent";
// import { orderStatisticsData } from "../../dashboard/constant";
import { ORDER_LIST } from "../../../actions/admin/customer-actions";
import OrderTable from "../../../components/common/table/OrderTable";
import {
  ORDER_LIST_COLUMNS,
  ORDER_STATUS_FILTER_OPTIONS,
  normalizeOrderStatus,
  resolveRawTrackingValue,
} from "../../../utils/orderListTable";
import {
  formatOrderDisplayStatusLabel,
  getOrderDisplayStatusBackground,
} from "../../../utils/orderDisplayStatus";

const OrderManagement = () => {
  const dispatch = useDispatch();
  // const [statisticsData, setStatisticsData] = useState(orderStatisticsData);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const orderListFunc = useCallback(() => {
    dispatch({
      type: ORDER_LIST, payload: {
        search: debouncedSearch,
        status: statusFilter,
        page,
        limit: rowsPerPage
      }
    });
  }, [dispatch, debouncedSearch, statusFilter, page, rowsPerPage]);

  useEffect(() => {
    orderListFunc();
  }, [orderListFunc]);

  const { recordList: orderList, total, isLoading } = useSelector(
    (state) => state?.orderData
  );

  const columns = [...ORDER_LIST_COLUMNS, "ACTION"];

  const allRecords =
    orderList?.map((item) => {
      const orderStatus = normalizeOrderStatus(item.order_status);
      const isAllApproved = item.order_details?.length > 0 && item.order_details.every(d => d.item.status === "approved");
      return {
        id: item.id,
        order_number: item.order_number,
        approved_items_count: Number(item.approved_items_count) || 0,
        raw_tracking_number: resolveRawTrackingValue(item, "tracking_number"),
        raw_carrier: resolveRawTrackingValue(item, "carrier"),
        raw_tracking_url: resolveRawTrackingValue(item, "tracking_url"),
        items: item.order_details?.map((d) => d.itemId),
        activeStatus: orderStatus,
        payment_status: item.payment_status,
        payment_proof: item.payment_proof,
        reference_number: item.reference_number,
        payment_note: item.payment_note,
        status: (
          <>
            <span
              style={{
                backgroundColor: getOrderDisplayStatusBackground(item),
                fontWeight: "bold",
                display: "inline-block",
                color: "white",
                padding: "4px 8px",
                borderRadius: "20px",
                minWidth: "90px",
                textAlign: "center",
              }}
            >
              {formatOrderDisplayStatusLabel(item)}
            </span>
            {(isAllApproved && orderStatus === "pending") && (
              <Tooltip title="All order items are approved — you can approve this order" arrow>
                <IconButton>
                  <InfoIcon color="primary" />
                </IconButton>
              </Tooltip>
            )}
          </>
        ),
      }
    }) || [];

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler); // cleanup on each change
    };
  }, [searchTerm]);

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(1);
  };

  return (
    <StyledWrapper>
      <StyledWelcomeBanner>
        {/* <DashboardStatistics idDataList={orderStatisticsData || []} /> */}
      </StyledWelcomeBanner>

      <StyledTableLayout>
        <StyledTypographyText>ORDER MANAGEMENT</StyledTypographyText>

        <StyledBoxStyle>
          <StyledCustomerSearch
            placeholder="Search by Order id, Customer name email, Items and locker assignments"
            variant="outlined"
            // value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <StyledSearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <StyledStatusFilter
            value={statusFilter}
            onChange={handleStatusFilterChange}
            displayEmpty
            inputProps={{ "aria-label": "Filter by status" }}
          >
            {ORDER_STATUS_FILTER_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledStatusFilter>
        </StyledBoxStyle>

        <StyledOrdersContainer>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <OrderTable
                columns={columns}
                rows={allRecords}
                recordList={orderListFunc}
                orderDetailBasePath="/admin/orders"
                editableTracking
              />
              <TablePagination
                component="div"
                count={total || 0}
                page={page - 1}
                onPageChange={(event, newPage) => setPage(newPage + 1)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(1);
                }}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            </>
          )}
        </StyledOrdersContainer>
      </StyledTableLayout>
    </StyledWrapper>
  );
};

export default OrderManagement;
